import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, Inject, NgZone, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs';
import { MyErrorStateMatcher } from 'src/app/auth/login/login.component';

@Component({
  selector: 'app-recall-dialog',
  templateUrl: './recall-dialog.component.html',
  styleUrl: './recall-dialog.component.css'
})
export class RecallDialogComponent {
  @ViewChild('autosize') autosize: CdkTextareaAutosize;

  recallForm: FormGroup;
  matcher = new MyErrorStateMatcher();
  isLoading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<RecallDialogComponent>,
    private _ngZone: NgZone
  ) {
    this.recallForm = new FormGroup({
      voidReason: new FormControl('', [Validators.required]),
    });
  }

  triggerResize() {
    this._ngZone.onStable.pipe(take(1)).subscribe(() => this.autosize.resizeToFitContent(true));
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    if (this.recallForm.valid) {
      const voidReason = this.recallForm.get('voidReason').value;
      this.dialogRef.close(voidReason);
    }
  }
}

